import {Component, Element, h, Prop} from "@stencil/core";
import {StringUtils} from "../../core/utils/StringUtils";
import {WebUtils} from "../../core/utils/WebUtils";

@Component({
    tag: 'snt-footer',
    styleUrl: "footer-component.scss",
    shadow: false
})
export class FooterComponent {

    public static readonly TAG_NAME = "snt-footer";

    @Element() element!: HTMLElement;

    @Prop() styleClasses:string = StringUtils.empty();

    render() {
        return (
            <div class={WebUtils.generateClasses(["footer"], this.styleClasses)}>
                <div class="spacings">
                    <slot />
                </div>
            </div>
        )
    }
}
